import React, { useEffect, useState } from "react";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Text,
  Image, useMediaQuery,
} from "@chakra-ui/react";
import { MathProblem } from "../types";
import APButton from "./APButton";
import {FormattedMessage} from "react-intl";

interface APCorrectnessDialogProps {
  open: boolean;

  onRestart: () => void;
  onQuit: () => void;
  correctCount: number;
  problemsCount: number;
}

function APCorrectnessDialog({
  open,
  onQuit,
  onRestart,
  correctCount,
  problemsCount,
}: APCorrectnessDialogProps) {
  const [isOpen, setOpen] = useState(false);
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");

  useEffect(() => {
    setOpen(open);
  }, [open]);

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={() => setOpen(false)}
      >
        <ModalOverlay>
          <ModalContent
            sx={{ width: { base: "calc(100% - 48px)", md: "100%" }, maxWidth: isLargeScreen ? "36rem" : "28rem" }}
          >
            <ModalBody className="ap-dialog-body">
              <Box
                sx={{
                  textAlign: "center",
                  fontSize: isLargeScreen ? "30px" : "24px",
                  fontWeight: "bold",
                  paddingTop: isLargeScreen ? "26px" : "20px",
                }}
              >
                <FormattedMessage id="exercise-completed-title" defaultMessage={`Exercice complété!`} />
              </Box>
              <div className="complete-image">
                <Image
                  src={`${process.env.REACT_APP_BASE_URL}complete.png`}
                  alt="complete"
                  sx={{ marginLeft: "auto", marginRight: "auto" }}
                />
              </div>
              <Box sx={{ width: "100%", padding: isLargeScreen ? "30px" : "24px" }}>
                <Box
                  sx={{
                    background: "#F5F3EF",
                    padding: isLargeScreen ? "16px" : "12px",
                    borderRadius: "12px",
                    textAlign: "center",
                  }}
                >
                  <Text sx={{ fontSize: isLargeScreen ? "36px" : "28px", fontWeight: 900 }}>
                    {correctCount}/{problemsCount}
                  </Text>
                  <Text>
                    <FormattedMessage id="successful-questions" defaultMessage={`Questions réussies`} />
                  </Text>
                </Box>
              </Box>
            </ModalBody>

            <ModalFooter className="ap-dialog-footer">
              <>
                <Box
                  sx={{
                    display: "flex",
                    columnGap: 2,
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <APButton
                    onClick={onRestart}
                    colorScheme="primary"
                    sx={{
                      px: isLargeScreen ? "3.15rem" : "2.5rem",
                      fontSize: isLargeScreen ? "1.26rem" : "1rem",
                      height: isLargeScreen ? "50px" : "40px"
                    }}
                  >
                    <FormattedMessage id="restart-button" defaultMessage={`Recommencer`} />
                  </APButton>
                  <APButton
                    onClick={onQuit}
                    sx={{
                      px: isLargeScreen ? "3.15rem" : "2.5rem",
                      fontSize: isLargeScreen ? "1.26rem" : "1rem",
                      height: isLargeScreen ? "50px" : "40px"
                    }}
                  >
                    <FormattedMessage id="quit-button" defaultMessage={`Quitter`} />
                  </APButton>
                </Box>
              </>
            </ModalFooter>
          </ModalContent>
        </ModalOverlay>
      </Modal>
    </>
  );
}

export default APCorrectnessDialog;
